module.exports = __webpack_public_path__ + "img/box-verification.e4dc9e44.jpg";